import React, { useRef } from 'react'
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, Button } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface IRetryDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  message: any
}

function RetryDialog({ isOpen, onClose, message }: IRetryDialogProps): JSX.Element {
  const cancelRef = useRef<HTMLButtonElement>(null)
  const { t } = useTranslation()

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent padding={'10px'}>
          <AlertDialogHeader fontSize='24px' fontWeight='700' lineHeight='33.6px' textAlign='center'>
            {t('retry_modal_title')}
          </AlertDialogHeader>

          <AlertDialogBody fontSize='16px' fontWeight='400' lineHeight='22.4px' textAlign='center'>
            {message ? `${message.message} (${message.statusCode})` : 'no data'}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button variant={'primary'} onClick={onClose} ml={3}>
              {t('retry_button')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export { RetryDialog }
